import { defineStore } from "pinia";

export const useUserPath = defineStore("zhihao-path", {
    state: (): { fromPath: string } => ({
        fromPath: ""
    }),
    getters: {},
    actions: {
        setPath(path: string) {
            this.fromPath = path;
        }
    }
});
